<template>
    <div class="aup-base-photo-capture">
        <div v-if="uploadStep == 0" class="w-100 cd-flex justify-content-center align-items-center text-center">
            <div>
                <p class="mb-4 t-error">Something went wrong</p>
                <BaseButton @click="uploadStep = 1" :filled="false" color="black" border="thin">TRY AGAIN</BaseButton>
            </div>
        </div>

        <div v-if="uploadStep == 1" class="w-100">
            <form class="w-100 d-flex justify-content-center align-items-center position-relative text-center">
                <span style="margin-top: 64px!important;">
                    <IconUpload/>
                    <h4 class="t-primary my-4">Drag & Drop<br/>Image to Upload</h4>
                    <BaseButton class="aup-base-photo-capture__select-file" :filled="false" color="black" border="thin">OPEN THE FILE BROWSER</BaseButton>
                    <input class="aup-base-photo-capture__input" type="file" accept="image/*,.jpg,.png,.jpeg" ref="uploadInput" @change="filesChange($event.target)">
                    <p class="t-micro mt-2">Max file size accepted is 30 MB</p>
                </span>
            </form>
        </div>

        <div v-if="uploadStep == 2" class="w-100 d-flex justify-content-center align-items-center text-center">
            <div>
                <p class="mb-4">Uploading 1 file</p>
                <BaseBoxLoader class="m-auto"/>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .aup-base-photo-capture {

        min-height: 440px;

        &__input {
            display: inline-block;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            &:hover {
                cursor: pointer;
            }
        }
    }
</style>
<script>
import { UPLOAD_LIMITS } from '@/upload-service.js';

export default {
    name: 'BasePhotoCapture',
    props: {
        uploadErr: {
            type: String,
            default: ''
        },
        uploadStep: {
            type: Number,
            default: 1
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        filesChange(target) {
            this.selectedFiles = [...target.files];
            let ext = target.value.match(/\.([^\.]+)$/)[1];
            let fileTypeError = '';
            let fileSizeError = '';
            if (!['jpg', 'jpeg', 'png'].includes(ext.toLowerCase()) ) {
                fileTypeError = 'The photo upload must be a .jpg, .jpeg, or .png format';
            }
            if (this.selectedFiles[0].size > UPLOAD_LIMITS.MAX_FILE_BYTES) {
                fileSizeError = 'The photo upload must be less than 30 MB';
            }
            if (fileSizeError || fileTypeError) {
                if (fileSizeError) {
                    this.$emit('updateStatus', fileSizeError);
                } else {
                    console.log('file Type error');
                    this.$emit('updateStatus', fileTypeError)
                }
            } else {
                this.$emit('filesChanged', this.selectedFiles);
                this.$emit('updateStatus', '');
            }
        }
    }
};
</script>
